import config from '../../../config';
import Request from '../../Request';

export default function getReservationRevenueByDay(options, onSuccess, onFailure) {
  const { startDate, endDate } = options;
  return Request.get(`${config.apiUrl}/summaries/reservation_revenue_by_day?start_date=${startDate}&end_date=${endDate}`, onSuccess, onFailure);
}